import { assertResponseError } from './assert';
import { prepareRegionSuggests } from '../../mappers/regionSuggests';
import {
  fetchSearchRegionsCities,
  ISearchRegionsCitiesRequest,
  ISearchRegionsCitiesResponse200,
  ISearchRegionsCitiesResponse400,
} from '../../repositories/monolith-python/v1/search-regions-cities';
import { IApplicationContext } from '../../types/applicationContext';
import { IRegion } from '../../types/requestForm';

export const searchRegionSuggests = async (
  context: IApplicationContext,
  parameters: ISearchRegionsCitiesRequest,
): Promise<IRegion[]> => {
  const {
    httpApi,
    logger,
    custom: { subdomain },
  } = context;

  try {
    const response = await fetchSearchRegionsCities<ISearchRegionsCitiesResponse200, ISearchRegionsCitiesResponse400>({
      httpApi,
      parameters,
      config: {
        subdomain,
      },
    });

    assertResponseError(response);

    return prepareRegionSuggests(response.response.data);
  } catch (error) {
    logger.error(error, {
      comment: '[Degradation] Используется пустой список результатов поиска',
    });

    return [];
  }
};
